import { loginPageInfo } from "../config"

export const URL_RETAIL = loginPageInfo.getServerUrl() + "retail/"
export const URL_INCHARGE = loginPageInfo.getServerUrl() + "inCharge/"

//Retail
export const URL_RETAIL_ADD = URL_RETAIL + 'addRetail'
export const URL_RETAIL_EDIT = URL_RETAIL + 'editRetail'
export const URL_RETAIL_GET_LIST = URL_RETAIL + 'getRetailList'
export const URL_RETAIL_GET_LIST_ENABLE = URL_RETAIL + 'getRetailListEnable'
export const URL_RETAIL_GET_DETAIL = URL_RETAIL + 'getRetailDetail'
export const URL_RETAIL_CHECK_HNKID = URL_RETAIL + 'checkRetailHNKID'

//inCharge
export const URL_INCHARGE_SALES_GET_LIST = URL_INCHARGE + 'getInChargeSalesList'
export const URL_INCHARGE_DISTRIBUTION_GET_LIST = URL_INCHARGE + 'getInChargeDistributionList'

